import React from "react";
import NtfyDot from "graphics/icons/NtfyDot";
import NtfyDotDark from "graphics/icons/NtfyDotDark";

const EfficeDot = ({ ntfy, dark = false }) => {
  if (ntfy) {
    return (
      <div className={`effice-dot`}>{dark ? <NtfyDotDark /> : <NtfyDot />}</div>
    );
  } else {
    return null;
  }
};

export default EfficeDot;
